export const RC_CHECK_STATE = 'RC_CHECK_STATE';
export const RC_CONNECT = 'RC_CONNECT';
export const RC_OPEN = 'RC_OPEN';
export const RC_DISCONNECT = 'RC_DISCONNECT';
export const RC_CLOSE = 'RC_CLOSE';
export const RC_SEND = 'RC_SEND';
export const RC_REGISTER = 'RC_REGISTER';
export const RC_LOGIN = 'RC_LOGIN';
export const RC_SUBSCRIBE = 'RC_SUBSCRIBE';
export const RC_ROOM = 'RC_ROOM';
export const RC_ROOM_ALL = 'RC_ROOM_ALL';
export const RC_ROOM_ADD = 'RC_ROOM_ADD';
export const RC_ROOM_REMOVE = 'RC_ROOM_REMOVE';
export const RC_METHOD = 'RC_METHOD';
export const RC_NOTIFICATION = 'RC_NOTIFICATION';
export const RC_NOTIFICATION_CHECK = 'RC_NOTIFICATION_CHECK';
export const RC_ERROR = 'RC_ERROR';
export const RC_USER = 'RC_USER';
export const RC_REQUEST = 'RC_REQUEST';
export const RC_RESPONSE = 'RC_RESPONSE';
export const RC_MESSAGE_ALL = 'RC_MESSAGE_ALL';
export const RC_MESSAGE_DIRECT = 'RC_MESSAGE_DIRECT';
export const RC_MESSAGE_NEW = 'RC_MESSAGE_NEW';
export const RC_MESSAGE_UNREAD = 'RC_MESSAGE_UNREAD';
export const RC_TYPING_SEND = 'RC_TYPING_SEND';
export const RC_TYPING_RECEIVE = 'RC_TYPING_RECEIVE';
